import axios from '../../../../../api/axios';
export const initialState = {
  isLoaded: false,
  freights: null,
  search: {},
  page: 1,
};
export const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'LOADING':
      return { ...state, isLoaded: false };
    case 'LOADED':
      return { ...state, isLoaded: true };
    case 'CHANGE_FIELDS':
      return {
        ...state,
        search: {
          ...state.search,
          [payload.name]: payload.value,
        },
      };
    case 'FREIGHTS':
      return { ...state, isLoaded: true, users: payload };
    case 'CHANGE_PAGE':
      return { ...state, page: payload };
    default:
      return { ...state };
  }
};
export const actions = {
  fetchingFreights: async (page = 1, limit, query) => {
    try {
      const { data: freights } = await axios.post(
        `/api/v1/admin/users/list/freights`,
        {
          page,
          limit,
          query,
        }
      );
      return freights;
    } catch (error) {
      return new Error(error);
    }
  },
};
